const ApuracoesVencidas = () => import('../../spa/apuracoes-vencidas/ApuracoesVencidas');
const ApuracoesVencidasList = () => import('../../spa/apuracoes-vencidas/ApuracoesVencidasList');
const DetalhesNegociacao = () => import('../../spa/negociacao/detalhes/DetalhesNegociacao');

export default {
  path: 'apuracoes-vencidas',
  component: ApuracoesVencidas,
  children: [
    {
      path: '',
      name: 'apuracoes-vencidas',
      component: ApuracoesVencidasList,
    },
    {
      path: 'detalhes/fixo/:id',
      name: 'verDetalhesFixo',
      component: DetalhesNegociacao,
      props: {
        tipoAcordo: 'FIXO',
        somenteLeitura: true,
        edicao: false,
        isApuracoesVencidas: true,
      },
    },
    {
      path: 'detalhes/tabloide/:id',
      name: 'verDetalhesTabloide',
      component: DetalhesNegociacao,
      props: {
        tipoAcordo: 'TABLOIDE',
        somenteLeitura: true,
        edicao: false,
        isApuracoesVencidas: true,
      },
    },
    {
      path: 'detalhes/negociacao_preco/:id',
      name: 'verDetalhesPreco',
      component: DetalhesNegociacao,
      props: {
        tipoAcordo: 'NEGOCIACAO_PRECO',
        somenteLeitura: true,
        edicao: false,
        isApuracoesVencidas: true,
      },
    },
    {
      path: 'detalhes/positivacao/:id',
      name: 'verDetalhesPositivacao',
      component: DetalhesNegociacao,
      props: {
        tipoAcordo: 'POSITIVACAO',
        somenteLeitura: true,
        edicao: false,
        isApuracoesVencidas: true,
      },
    },
    {
      path: 'detalhes/crescimento/:id',
      name: 'verDetalhesCrescimento',
      component: DetalhesNegociacao,
      props: {
        tipoAcordo: 'CRESCIMENTO',
        somenteLeitura: true,
        edicao: false,
        isApuracoesVencidas: true,
      },
    },
  ],
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/config/router/apuracoes-vencidas.js